'use strict';


let UKS = UKS || {};
let UTILS = UTILS || {};

UKS.utils = UTILS || {};

UKS.metaTags = {};

UKS.refinement = {
    groupRevealed: null,
    getCurrentCategorySlug: function() {
        return $('[data-category]').attr('data-category');
    },
    getCategoryName: function(slug) {
        var name = $('[data-param="' + slug + '"]').html();

        if (name) {
            name = name.trim();
        }

        return name;
    },
    getLabelName: function(slug) {
        var name = $('input[value="' + slug + '"]').parent().find('.js-label-name').html();

        if (name) {
            name = name.trim();
        }

        return name;
    },
    getCurrentLabelSlug: function() {
        return $('input[name="labelSlug"]:checked').val();
    },
    filterBy: function(type, value, withoutTopicRefinement) {
        var categorySlug = UKS.refinement.getCurrentCategorySlug();
        var labelSlug = UKS.refinement.getCurrentLabelSlug();
        var url;

        if (type === 'category') {
            if (withoutTopicRefinement) {
                url = value;
            } else {
                url = value + (labelSlug ? '/' + labelSlug : '');
            }

        } else if (type === 'label') {
            url = categorySlug + '/' + value;

        } else {
            url = categorySlug;
        }

        history.pushState({url: url}, null, url);
        UKS.pushStateCounter++;
        UKS.refinement.requestContent(url);
    },

    findParams: function(value) {
        if (value.indexOf('?') >= 0) {
            value += '/';
            return value;
        } else {
            value += '/?';
            return value;
        }
    },
    requestContent: function(url) {
        $('.loading').fadeIn();

        if (UKS.infiniteElement) {
            UKS.infiniteElement.destroy();
        }

        if ( url.slice(-1) === '/' ) {
            url = url.slice(0, -1);
        }

        url += (UKS.refinement.groupRevealed ? '?groupRevealed=' + UKS.refinement.groupRevealed : '');
        var newUrl = UKS.refinement.findParams(url);

        if ( newUrl.slice(-1) === '/' ) {
            newUrl = newUrl.slice(0, -1);
        }

        setTimeout(function() {
            $.ajax({
                url: newUrl + Math.random(),
                dataType: 'html',
                success: function(responseText) {

                    $('#js-content').replaceWith(responseText);

                    var codes = $('#js-content').find("script");
                    for (var i=0; i<codes.length; i++) {
                        eval(codes[i].text);
                    }

                    document.title = UKS.metaTags.title;
                    $('meta[name=description]').attr('content', UKS.metaTags.description);

                    // $('html, body').animate({ scrollTop: 0 }, 'slow');

                    Waypoint.destroyAll();
                    UKS.utils._animationedSections();
                    $('.js-equal-height').matchHeight();
                    UKS.utils._ajaxPopup();
                    UKS.refinement.init();

                    setTimeout(function() {
                        UKS.utils.infiniteScroll(UKS.utils.waypointCallback);
                        Waypoint.refreshAll();
                    }, 1000);

                    setTimeout(function() {
                        $('.loading').fadeOut();
                    }, 200);
                },

                error: function(responseText) {
                    setTimeout(function() {
                        $('.loading').fadeOut();
                    }, 200);
                }
            });
        }, 300);

        return false;
    },

    selectEvent: function() {

        $('.js-filter-ajax').on('change', function(e) {
            var self = this;
            var val = $(this).val();

            if (val !== '-1') {

                var filterType = self.getAttribute('data-filter-type'),
                    selectedOption = $(self).find(":selected"),
                    slug = val,
                    withoutTopicRefinement = selectedOption.data('no-topics') || false;

                UKS.refinement.filterBy(filterType, slug, withoutTopicRefinement);
            }
        });

    },

    init: function() {
        this.selectEvent();
    }
};


UKS.utils.navLeft = function() {;
    var leftMenuItem = $('.js-left-menu-item');
    var leftSubMenuItem = $('.js-left-sub-menu-item');
    var leftMenuBtn = $('.js-left-menu-btn');

    leftMenuBtn.on('click', function () {
        $(this).toggleClass('flex-container__nav-btn--yellow');

        if ($(this).hasClass('flex-container__nav-btn')) {
            $(this).next().toggleClass('flex-container__nav-mob');
        } else {
            $('.flex-container__nav').toggleClass('flex-container__nav-mob');
        }
    });
}

UKS.utils.makeEqualHeadline = function() {
    $('.js-equal-headline-block').each(function(i, elem) {
        $(elem)
            .find('.js-equal-headline')   
            .matchHeight({byRow: false}); 
    });
} 

UKS.utils.showMore = function() {
    if ( document.querySelector('.js-show-more') ) {
        var showMoreButtons = document.querySelectorAll('.js-show-more');

        [].forEach.call(showMoreButtons, function(showMoreButton) {
            showMoreButton.addEventListener("click", function( event ) {
                event.preventDefault();
                let targetId = event.currentTarget.getAttribute('data-target-id');
                document.querySelector('#' + targetId).style.display = 'block';
                this.parentNode.removeChild(this);
            }, false);
        });
    }
}


UKS.utils.showDeliveryOptions = function() {
    if ( document.querySelector('.js-delivery-options') ) {
        var deliveryOptionsButtons = document.querySelectorAll('.js-delivery-options');

        [].forEach.call(deliveryOptionsButtons, function(deliveryOptionsButton) {
            deliveryOptionsButton.addEventListener("click", function( event ) {
                event.preventDefault();
                let popup;
                if (this.nextElementSibling.classList.contains('js-delivery-popup')) {
                    popup = this.nextElementSibling;

                    popup.classList.contains('product-delivery__popup--open') ? popup.classList.remove('product-delivery__popup--open') : popup.classList.add('product-delivery__popup--open');

                }
                document.querySelector('.js-delivery-options-close').addEventListener("click", function() {
                    popup.classList.remove('product-delivery__popup--open');
                });

            }, false);
        });
    }
},


UKS.utils.cardNumberValidation = function() {
    if ( document.querySelector('#card-number') ) {
        let numberCardInput = document.querySelector('#card-number');

        numberCardInput.addEventListener("input", (event) => {
            event.preventDefault();

            var target = event.target, position = target.selectionEnd, length = target.value.length;

            target.value = target.value.replace(/[^\dA-Z]/g, '').replace(/(.{4})/g, '$1 ').trim();
            target.selectionEnd = position += ((target.value.charAt(position - 1) === ' ' && target.value.charAt(length - 1) === ' ' && length !== target.value.length) ? 1 : 0);

            target.value = target.value.substr(0, 19);
        });
    }
},

UKS.utils.closePopup = function(obj, sessionKey) {
    let popupWrapper = obj.parentElement.parentElement;

    popupWrapper.classList.remove('popup-wrapper--show');
    popupWrapper.classList.add('popup-wrapper--was-shown');

    if ( sessionKey ===  'popupPromoCode') {
        sessionKey = sessionKey + '-' + document.querySelector('.js-popup-promocode').getAttribute('data-id');
    }

    sessionStorage.setItem(sessionKey, 1);

    // open popup with promocode if exists and wasnt shown already
    if ( document.querySelector('.js-popup-promocode:not(.popup-wrapper--was-shown)') ) {
        if ( !TNS.cookie.showCookie('promoCodeConfirmed-' + document.querySelector('.js-popup-promocode').getAttribute('data-id')) ) {
            if ( !sessionStorage.getItem('popupPromoCode-' + document.querySelector('.js-popup-promocode').getAttribute('data-id')) ) {
                setTimeout(function(){
                    document.querySelector('.js-popup-promocode').classList.add('popup-wrapper--show');
                }, 2000);
            }
        }
    }

    return false;
},


UKS.geo = {
    placeSearch: '',
    autocomplete: '',
    componentForm: {
        street_number: 'short_name',
        route: 'long_name',
        locality: 'long_name',
        postal_town: 'long_name',
        postal_code: 'short_name',
        administrative_area_level_1: 'long_name'
    },

    loadScript: function(map) {
        var protocol = location.protocol,
            urlApi = '';

        if (protocol === 'http:') {
            urlApi = 'maps.googleapis.com';
        } else {
            urlApi = 'maps-api-ssl.google.com';
        }

        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.defer = true;
        script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyBX_bYm4TkKnnV0BomV_NPrduEQP8H9gzg&language=en&libraries=places&callback=UKS.geo.initAutocomplete';

        document.body.appendChild(script);
    },

    initAutocomplete () {
        // Create the autocomplete object, restricting the search to geographical
        // location types.
        UKS.geo.autocomplete = new google.maps.places.Autocomplete(
            /** @type {!HTMLInputElement} */(document.getElementById('autocomplete')),
            {
                types: ['geocode'],
                componentRestrictions: {country: "uk"}
            }
        );

        // When the user selects an address from the dropdown, populate the address
        // fields in the form.
        UKS.geo.autocomplete.addListener('place_changed', UKS.geo.fillInAddress);

        google.maps.event.addDomListener(document.getElementById('autocomplete'), 'keydown', function(event) {
            if (event.keyCode === 13) {
                event.preventDefault();
            }
        });

        var dummyRandom = Date.now();

        document.getElementById('autocomplete').setAttribute('autocomplete', dummyRandom);

        setTimeout(function(){
            document.getElementById('autocomplete').setAttribute('autocomplete', dummyRandom);
        }, 1000);
    },

    fillInAddress () {
        // Get the place details from the autocomplete object.
        var place = UKS.geo.autocomplete.getPlace();

        if ( document.querySelector('.js-show-more') ) {
            document.querySelector('#more-form').style.display = 'block';
            document.querySelector('.js-show-more').parentNode.removeChild(document.querySelector('.js-show-more'));
        }

        for (var component in UKS.geo.componentForm) {
            if (UKS.geo.componentForm.hasOwnProperty(component)) {
                if (document.getElementById(component)) {
                    document.getElementById(component).value = '';
                    document.getElementById(component).disabled = false;
                }
            }
        }

        // Get each component of the address from the place details
        // and fill the corresponding field on the form.
        for (var i = 0; i < place.address_components.length; i++) {
            var addressType = place.address_components[i].types[0];
            if (UKS.geo.componentForm[addressType]) {
                var val = place.address_components[i][UKS.geo.componentForm[addressType]];

                if ( document.getElementById(addressType) ) {
                    document.getElementById(addressType).value = val;
                }

                if (addressType === 'postal_town') {
                    document.getElementById('locality').value = val;
                }

                /*
                if (addressType === 'administrative_area_level_1') {
                    document.getElementById('country').value = val;
                }*/
            }
        }
    },

    geolocate () {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function(position) {
                var geolocation = {
                lat: position.coords.latitude,
                lng: position.coords.longitude
                };
                var circle = new google.maps.Circle({
                center: geolocation,
                radius: position.coords.accuracy
                });
                UKS.geo.autocomplete.setBounds(circle.getBounds());
            });
        }

    }
};


UKS.shoppingBag = {
    clickEvent () {
        if ( document.querySelector('.js-shopping-bag-button') ) {
            let shoppingBagButton = document.querySelector('.js-shopping-bag-button'),
                shoppingBag = document.querySelector('.js-shopping-bag');

            shoppingBagButton.addEventListener("click", (event) => {
                event.preventDefault();
                UKS.shoppingBag.toggleShoppingBag();

                return false;
            });
        }
    },

    closeShoppingBag () {
        if ( document.querySelector('.js-close-shopping-bag') ) {
            let shoppingBagButton = document.querySelector('.js-close-shopping-bag'),
                shoppingBag = document.querySelector('.js-shopping-bag');

            shoppingBagButton.addEventListener("click", (event) => {
                event.preventDefault();
                shoppingBag.classList.remove('shopping-bag--show');
                // UKS.windowSwitchScroll();
                // $('body').css('position', 'static');

                return false;
            });
        }
    },

    toggleShoppingBag () {
        if ( document.querySelector('.js-shopping-bag') ) {
            let shoppingBag = document.querySelector('.js-shopping-bag');

            if (shoppingBag.classList.contains('shopping-bag--show')) {
                shoppingBag.classList.remove('shopping-bag--show');
                $('body').css('position', 'static');
                
            } else {
                shoppingBag.classList.add('shopping-bag--show');
                // $('body').css('position', 'fixed');
                
            }
        }
    },

    init () {
        this.clickEvent();
        this.closeShoppingBag();
    }
};


// UKS.windowSwitchScroll = function() {

//     $(".shopping-bag-popup").bind('mouseleave touchend', function(e) {
//         $(window).off('scroll');
//     });

//     $(".shopping-bag-popup").bind('mouseenter touchstart', function(e) {
//         let current = $(window).scrollTop();

//         $(window).scroll(function(event) {
//             $(window).scrollTop(current);
//         });
//     });
// };



UKS.product = {
    increase (inputId, productPrice = 'product-price') {
        let targetInput = document.querySelector('#' + inputId);

        targetInput.value = (targetInput.value * 1) + 1;
        UKS.product.calculatePrice(targetInput.value, productPrice);
    },

    decrease (inputId, productPrice = 'product-price') {
        let targetInput = document.querySelector('#' + inputId),
            targetInputValue = targetInput.value*1;

        if ( targetInputValue > 1) {
            targetInput.value = (targetInput.value * 1) - 1;
            UKS.product.calculatePrice(targetInput.value, productPrice);
        }
    },

    calculatePrice (quantity, productPrice = 'product-price') {
        let priceEl = document.querySelector('#' + productPrice),
            basePrice = priceEl.getAttribute('data-base-price')*1,
            calculatedPrice = 0.00;

        calculatedPrice = quantity * basePrice;
        priceEl.innerHTML = calculatedPrice.toFixed(2);
    },

    priceInputOnChangeEvent () {
        if (document.querySelector('#js-quantity')) {
            let priceEl = document.querySelector('#js-quantity');

            priceEl.addEventListener("input", (event) => {
                if(event.target.value < 0) {
                    event.target.value = 1;
                }
                UKS.product.calculatePrice(event.target.value);
            }, false);
        }
    },

    init () {
        this.priceInputOnChangeEvent();
    }
}

UKS.openSocialLoginPopup = function(options) {
    if (!options.authUrl) {
        return false;
    }

    const signinWindow = window.open(options.authUrl, "SignIn", "width=780,height=410,toolbar=0,scrollbars=0,status=0,resizable=0,location=0,menuBar=0,left=" + 500 + ",top=" + 200);
};

UKS.shop = {
    bagSummaryElement: $('#js-bag-summary'),
    bagPopupElement: $('.shopping-bag-popup'),
    bagPopupDynamicElement: $('#js-bag-popup'),

    bagCheckoutForm: $('.js-form-shopping-bag'),
    

    addToBag (productId, form) {
        if (!productId) {
            return false;
        }

        var quantity = form ? form.querySelector("input[name='quantity']").value : $('#js-quantity').val();
        // $('.l-main .loading').fadeIn();

        if ( quantity == undefined) {
            var quantity = 1;
        }

        // console.log(quantity,productId);

        return callApi({
            url: '/api/shop/addToBag',
            method: 'POST',
            data: 'product_id=' + productId + '&quantity=' + quantity,
            onSuccess: UKS.shop.addToBagCallback
        });
    },

    addToWishlist (productId, form) {
        if (!productId) {
            return false;
        }

        var quantity = form ? form.querySelector("input[name='quantity']").value : $('#js-quantity').val();
        // $('.l-main .loading').fadeIn();

        // console.log(quantity,productId);

        return callApi({
            url: '/api/shop/addToBag',
            method: 'POST',
            data: 'product_id=' + productId + '&quantity=' + quantity,
            onSuccess: UKS.shop.addToWishlistCallback
        });
    },

    addToBagCallback (response) {
        document.querySelector('.shopping-bag-basket__qty').innerHTML = response.counter + ' item' + (response.counter === 1 ? '' : 's' );
        // $('.shopping-bag-basket__qty').fadeOut();
        UKS.shop.openBagPopup();

        // UKS.trackByFacebookPixel('AddToCart', response.details ? response.details : null);
    },

    addToWishlistCallback (response) {
        document.querySelector('.shopping-bag-basket__qty').innerHTML = response.counter + ' item' + (response.counter === 1 ? '' : 's' );
        // $('.shopping-bag-basket__qty').fadeOut();
        UKS.shop.openWishlistPopup();

        // UKS.trackByFacebookPixel('AddToCart', response.details ? response.details : null);
    },

    removeProduct (productId, popup) {
        if (!productId) {
            return false;
        }

        return callApi({
            isPopup: popup,
            url: '/api/shop/removeProduct',
            method: 'DELETE',
            data: 'product_id=' + productId,
            onSuccess: popup ? bagPopupSuccessCallback : bagSummarySuccessCallback
        });
    },

    changeQuantity (productId, increment, popup) {
        increment = increment || false;

        if (!productId) {
            return false;
        }

        return callApi({
            isPopup: popup,
            url: '/api/shop/changeQuantity',
            method: 'POST',
            data: 'product_id=' + productId + '&increment=' + increment,
            onSuccess: popup ? bagPopupSuccessCallback : bagSummarySuccessCallback
        });
    },

    changeManualQuantity (productId, startValue, newValue, popup) {
        var increment = (newValue*1 > startValue*1);

        if ( (newValue*1) % 1 !== 0 ) {
            return false;
        }

        if (!productId) {
            return false;
        }

        return callApi({
            isPopup: popup,
            url: '/api/shop/changeQuantity', 
            method: 'POST',
            data: 'product_id=' + productId + '&increment=' + increment + '&amount=' + Math.abs( (startValue*1) - (newValue*1) ),
            onSuccess: popup ? bagPopupSuccessCallback : bagSummarySuccessCallback
        });
    },

    changeDeliveryOption (deliveryId, popup) {
        if (!deliveryId) {
            return false;
        }

        return callApi({
            isPopup: popup,
            url: '/api/shop/changeDeliveryOption',
            method: 'POST',
            data: 'delivery_id=' + deliveryId,
            onSuccess:  popup ? bagPopupSuccessCallback : bagSummarySuccessCallback
        });
    },

    assignDeliveryCostForCounty ($selectElement, url) {
        let countyId = $($selectElement).val();
        let messageBox = $('.js-response-county');

        if (!countyId) {
            messageBox.find('p').addClass('hidden');
            return false;
        }

        return callApi({
            isPopup: false,
            url: url,
            method: 'GET',
            data: 'county_id=' + countyId,
            onSuccess: bagSummarySuccessCallback,
            errorCallback: (response => {
                messageBox.find('p').html(response.responseJSON.message).removeClass('hidden');
            })
        });
    },

    assignDeliveryCostForCountyCheckout (selectElement, url, step) {
        let countyId = $(selectElement).val();

        if (!countyId) {
            return false;
        }

        return callApi({
            isPopup: false,
            url: url,
            method: 'GET',
            data: 'county_id=' + countyId + '&checkout=true&step=' + step,
            onSuccess: checkoutFormSuccessCallback,
        });
    },

    applyDiscount (promoCode, popup) {
        if (!promoCode) {
            return false;
        }

        console.log(promoCode, popup);

        return callApi({
            isPopup: popup,
            url: '/api/shop/applyDiscount', 
            method: 'POST',
            data: 'promo_code=' + promoCode,
            onSuccess: popup ? bagPopupSuccessCallback : bagSummarySuccessCallback,
            errorCallback: promoCodeFailed
        });
    },

    applyDiscountCheckout (promoCode, step) {
        if (!promoCode) {
            return false;
        }

        step = step * 1;

        return callApi({
            isPopup: false,
            url: '/api/shop/applyDiscount',
            method: 'POST',
            data: 'promo_code=' + promoCode + '&checkout=true&step=' + step,
            onSuccess: step === 3 ? reload : checkoutFormSuccessCallback,
            errorCallback: promoCodeFailed
        });
    },

    removeDiscountCheckout (step) {
        step = step * 1;

        return callApi({
            isPopup: false,
            url: '/api/shop/removeDiscount?checkout=true&step=' + step,
            method: 'DELETE',
            onSuccess: step === 3 ? reload : checkoutFormSuccessCallback,
        });
    },

    removeDiscount (popup) {
        return callApi({
            isPopup: popup,
            url: '/api/shop/removeDiscount',
            method: 'DELETE',
            onSuccess: popup ? bagPopupSuccessCallback : bagSummarySuccessCallback
        });
    },

    restoreAutomaticDiscountCheckout (step) {
        step = step * 1;

        return callApi({
            isPopup: false,
            url: '/api/shop/restoreDiscount?checkout=true&step=' + step,
            method: 'POST',
            onSuccess: step === 3 ? reload : checkoutFormSuccessCallback,
        });
    },

    restoreAutomaticDiscount (popup) {

        return callApi({
            isPopup: popup,
            url: '/api/shop/restoreDiscount',
            method: 'POST',
            onSuccess: popup ? bagPopupSuccessCallback : bagSummarySuccessCallback
        });
    },

    openBagPopup () {
        return callApi({
            url: '/api/shop/bag?popup=1', 
            onSuccess: fetchPopupBagContent
        });
    },

    openWishlistPopup () {
        return callApi({
            url: '/api/shop/bag?popup=1', 
            onSuccess: fetchPopupBagContent
        });
    },

    submitPayment({amount, currency}) {
        let form = document.getElementById('js-checkout-step-2');
        
        const billingDetails = {
            name: document.getElementById('address[person]').value,
            address: {
                line1: document.getElementById('address[house_number]').value,
                line2: document.getElementById('address[street_name]').value,
                city: document.getElementById('address[city]').value,
                postal_code: document.getElementById('address[post_code]').value,
                country: document.getElementById('address[country_shortcode]').value,
            }
        };

        $('#js-checkout-step-2 .loading').fadeIn(410, function() {
            stripe.createPaymentMethod(
                'card',
                cardNumber,
                {
                    billing_details: billingDetails
                }
            ).then(function(result) {
                if (result.error) {
                    // Show error in payment form
                    showErrorMessage({message: result.error.message});
                    hideLoadingLayer();
                } else {
                    // Otherwise send paymentMethod.id to your server (see Step 2)
                    $.ajax({
                        url: '/api/shop/payment',
                        method: 'POST',
                        contentType: 'application/json',
                        data: JSON.stringify({ payment_method_id: result.paymentMethod.id }),
                        error: result => {
                            handleServerResponse(result.responseJSON);
                        },
                        success: result => {
                            handleServerResponse(result);
                        }
                    });
                }
            });
        });

        function handleServerResponse(response) {
            if (response.error) {
                // Show error from server on payment form
                showErrorMessage({message: response.message});
                hideLoadingLayer();

            } else if (response.requires_3ds_secure) {
                // Use Stripe.js to handle required card action
                stripe.handleCardAction(
                    response.payment_intent_client_secret
                ).then(function(result) {
                    if (result.error) {
                        // Show error in payment form
                        showErrorMessage({message: result.error.message});
                        hideLoadingLayer();
                    } else {
                        // The card action has been handled
                        // The PaymentIntent can be confirmed again on the server
                        $.ajax({
                            url: '/api/shop/payment',
                            method: 'POST',
                            contentType: 'application/json',
                            data: JSON.stringify({ payment_intent_id: result.paymentIntent.id }),
                            error: result => {
                                handleServerResponse(result.responseJSON);
                            },
                            success: result => {
                                form.submit();
                            }
                        });
                    }
                });
            } else {
                form.submit();
            }
        };

        function showErrorMessage({message}) {
            let errorElement = document.getElementById('card-errors');
            errorElement.textContent = message;
            $('.form__response.form__response--error').removeClass('hidden');
        }

        function hideLoadingLayer() {
            $('#js-checkout-step-2 .loading').fadeOut();
        }
    },

    changeBillingAddressOption (isChecked) {
        var billingAddressLayer = $('.js-billing-address');

        if (isChecked) {
            billingAddressLayer.fadeOut();

            $(billingAddressLayer).each(function() {
                $(this).find(':input:not(.btn)').removeAttr('required');
            });

        } else {
            billingAddressLayer.fadeIn();

            $(billingAddressLayer).each(function() {
                $(this).find(':input:not(.btn)').attr('required');
            });
        }
    },

    submit ( formId ) {
        var form = $('#' + formId);
        form.find('.loading').fadeIn();
        document.getElementById(formId).submit();
    }
};

//
//
// Common Shop Functions
//
//

function fetchPopupBagContent(response) {
    UKS.shop.bagPopupDynamicElement.html(response);
    UKS.shoppingBag.toggleShoppingBag();
    // hideBagSummaryLoading();

    return false;
}

function callApi(options) {
    
    if (!options.url) {
        return false;
    }

    var ajaxDetails = {
        url: options.url + (options.isPopup ? '?popup=1' : ''),
        method: options.method || 'GET'
    };

    if (options.data) {
        ajaxDetails.data = options.data;
    }

    // showBagSummaryLoading();
    $.ajax(ajaxDetails)
        .then(function(response) {
            if (options.onSuccess) {
                options.onSuccess(response);
            }
        }, function(response) {
            if (options.errorCallback) {
                options.errorCallback(response);
            }
            // hideBagSummaryLoading();
        });
    return false;
}

function bagSummarySuccessCallback(response) {
    UKS.shop.bagSummaryElement.html(response);
    // hideBagSummaryLoading();
}

function bagPopupSuccessCallback(response) {
    UKS.shop.bagPopupDynamicElement.html(response);
    // hideBagSummaryLoading();
}


function checkoutFormSuccessCallback(response) {
    UKS.shop.bagCheckoutForm.html(response);
    // hideBagSummaryLoading();
}

function promoCodeFailed(response) {
    if (response.responseJSON.error === true) {
        if ( $('.promo-code__error').length === 0 ) {
            $('.promo-code').addClass('promo-code--failed');
            $('.promo-code').append( '<span class="promo-code__error">'+response.responseJSON.message+'</span>' );
        } else {
             $('.promo-code__error').html(response.responseJSON.message);
        }
    }
}

function reload() {
    window.location.reload(true);
}

// function showBagSummaryLoading() {
//     UKS.shop.bagPopupLoadingElement.fadeIn();
//     UKS.shop.bagSummaryLoadingElement.fadeIn();
//     UKS.shop.bagCheckoutFormLoading.fadeIn();
// }

// function hideBagSummaryLoading() {
//     UKS.shop.bagPopupLoadingElement.fadeOut();
//     UKS.shop.bagSummaryLoadingElement.fadeOut();
//     UKS.shop.bagCheckoutFormLoading.fadeOut();
// }

UKS.form = {
    contact (form) {
        let data = $(form).serialize(),
            loading = true,
            url;

        console.log(data);

        url = '/ajax/contact';

        // $('#js-contact-form .loading').fadeIn();
        $(form).find('button[type="submit"]').text('Sending...');

        $.ajax({
            url: url, 
            method: 'POST',
            data: data,
            dataType: 'json'
        })
        .then(function(response) {
            $(form).find('button[type="submit"]').text('Submit');
            // $('#js-contact-form .loading').fadeOut();

            if (response.url) {
                window.location.href = response.url;
            } else {
                // $('#js-contact-form .loading').fadeOut();

                if ( $(form).find('.form__response--ok').length === 0 ) {
                    $(form).prepend( '<div class="form__response form__response--ok"><p>'+response.message+'</p></div>' );
                } else {
                    $('.form__response--ok p').html(response.message);
                }
            }

            // remove error response if exists
            $(form).find('.form__response--error').remove();
            $(form)[0].reset();

        }, function(response) {
            let errorMessage = '';

            if (response.status == 422) {
                for (var field in response.responseJSON) {
                    if (response.responseJSON.hasOwnProperty(field)) {
                        errorMessage += response.responseJSON[ field ].join('<br>') + '<br>';
                    }
                }
            } else if (response.responseJSON.message) {
                errorMessage = response.responseJSON.message;
            }

            if (errorMessage) {
                if ( $(form).find('.form__response--error').length === 0 ) {
                    $(form).prepend( '<div class="form__response form__response--error"><p>'+errorMessage+'</p></div>' );
                } else {
                    $('.form__response--error p').html(errorMessage);
                }
            }

            // remove success response if exists
            $(form).find('.form__response--ok').remove();

            $(form).find('button[type="submit"]').text('Submit');
            // $('#js-contact-form .loading').fadeOut();
        });

        return false;
    },

    enquire (form_btn) {
        var userData = $(form_btn).closest('form').serialize();
        var values = {};
        var emptyFileds = [];

        $.each($(form_btn).closest('form').serializeArray(), function( i, field) {
            var form = $(form_btn).closest('form');
            var thisfield = form.find( "[name='"+field.name+"']").attr('required');

            if (field.value == "" && typeof thisfield !== typeof undefined  && thisfield !== false) {
                emptyFileds.push(field.name);
            }
        });
        
        if (emptyFileds.length == 0 || emptyFileds[0] == "address") {
            event.preventDefault();
            $('.js-popup-enquire').addClass('popup-wrapper--show');
        } else {
            return;
        }
        
        $('.js-close-popup').on('click', function () {
             $('.js-popup-enquire').removeClass('popup-wrapper--show');
        });

        return userData;
    },

    enquireSend ( submit_btn, user_data) {
        event.preventDefault();
        var enquireMessage = $('#enquireFormMessage').serialize();
        var userData = UKS.form.enquire(user_data);

        if ($('#enquireFormMessage .form__textarea').val().length == 0) {
            event.preventDefault();
        } else {
            $.ajax({
                url: '/enquire',
                method: 'POST',
                dataType: 'json',     
                data: enquireMessage + "&" + userData,     
            })
            .then(function(response) {
                $('.js-popup-enquire').removeClass('popup-wrapper--show');
                $('.js-popup-enquire-sent').addClass('popup-wrapper--show');

                $('.js-close-popup').on('click', function () {
                    $('.js-popup-enquire-sent').removeClass('popup-wrapper--show');
                });
            }, function(response) {
                $('.js-popup-enquire').removeClass('popup-wrapper--show');
                $('.js-popup-enquire-not-sent').addClass('popup-wrapper--show');

                $('.js-close-popup').on('click', function () {
                    $('.js-popup-enquire-not-sent').removeClass('popup-wrapper--show');
                });
            });
        }
    },

    enquireNonUk (form) {
        event.preventDefault();
        var data = $(form).serialize()

        $.ajax({
            url: '/enquire',
            method: 'POST',
            dataType: 'json',     
            data: data,     
        })
        .then(function(response) {
            $('.js-popup-enquire-sent').addClass('popup-wrapper--show');

            $('.js-close-popup').on('click', function () {
                $('.js-popup-enquire-sent').removeClass('popup-wrapper--show');
            });
        }, function(response) {
            $('.js-popup-enquire-not-sent').addClass('popup-wrapper--show');

            $('.js-close-popup').on('click', function () {
                $('.js-popup-enquire-not-sent').removeClass('popup-wrapper--show');
            });
        });
    }
};

if ( document.getElementById('autocomplete') ) {
    UKS.geo.loadScript();
}

UKS.selectBoxes = function() {

    // $('select:not(.js-filter-ajax):not(.js-languages)').selectbox();

    $('.js-languages').each(function(index) {
        var self = this;
        $(self).css('display', 'none');
        $('.sbOptions a').attr('href', '');
        $(self).selectbox({
            onOpen: function (inst) {
                var id = inst.uid,
                    selectedText = $('#sbSelector_'+id).text(),
                    options = $('#sbOptions_'+id+' li');

                options.each(function(index) {
                    if ( $(this).find('a').text() === selectedText ) {
                        $(this).addClass('selected');
                    } else {
                        $(this).removeClass('selected');
                    }
                });
            },
            onClose: function (inst) {

            },
            onChange: function (val, inst) {
                $(self).val(val).change();

                if (val !== '-1') {

                    var selectSourceUID = inst.uid;
                    var sourceSelect = document.querySelector('[sb="'+selectSourceUID+'"]');
                    
                    $(sourceSelect).val(val).change();

                    var selectedOption = $(sourceSelect).find(":selected");

                    if (selectedOption.hasClass('js-open-language-modal')) {

                        var shortCode = selectedOption.data('shortcode');

                        $('#language-popup a:not(#language-popup-current,.btn--lang-' + shortCode + ')').hide();
                        $.magnificPopup.open({
                            items: {
                                src: '#language-popup',
                                type: 'inline'
                            },
                            callbacks: {
                                close: function() {
                                    $('#language-popup a:not(#language-popup-current,.btn--lang-' + shortCode + ')').show();
                                }
                            }
                        });
                    } else {

                        if (selectedOption.hasClass('lang__uk')) {
                            // $('#uk_form').submit();
                            document.getElementById("uk_form").submit();
                        }
                        else if (selectedOption.hasClass('lang__row')) {
                            // $('#us_form').submit();
                            document.getElementById("row_form").submit();
                        } 
                    }
                }
                if (val === 0) {
                    $(self).parent().find('.sbHolder').removeClass('selected');
                } else {
                    $(self).parent().find('.sbHolder').addClass('selected');
                }
            },
            effect: "slide"
        });
    });
}

UKS.cookie = {
    setCookie: function(name, val, days) {
        var expires;
        if (days) {
            var data = new Date();
            data.setTime(data.getTime() + (days * 24*60*60*1000));
            expires = "; expires="+data.toGMTString();
        } else {
            expires = "";
        }
        document.cookie = name + "=" + val + expires + "; path=/";
    },

    deleteCookie: function(name) {
        document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    },

    showCookie: function(name) {
        if (document.cookie!=='') {
            var cookies=document.cookie.split("; ");
            for (var i=0; i<cookies.length; i++) {
                var cookieName=cookies[i].split("=")[0];
                var cookieVal=cookies[i].split("=")[1];
                if (cookieName===name) {
                    return decodeURI(cookieVal);
                }
            }
        }
    }
};

UKS.purchasingOutsideUk = {
    continue: function() {
        UKS.cookie.setCookie('outsideUKConfirmed', 'noPurchaseConfirmed', 9999);
        document.querySelector('.js-popup-purchase-outside-uk').classList.remove('popup-wrapper--show');
    },

    enable: function() {
        $('.js-popup-purchase-outside-uk .loading').fadeIn();
        $.ajax({
            url: '/ajax/enablePurchasingOutsideUk',
            method: 'POST',
            dataType: 'json'
        })
        .then(function() {
            UKS.purchasingOutsideUk.continue();
            location.reload();
        }, function() {
            UKS.purchasingOutsideUk.continue();
        });
    },

    takeUserBack: function( referer , previousLangID) {
        $.ajax({
            url: '/ajax/takeUserBack',
            method: 'POST',
            dataType: 'json',          
            data: 'url=' + referer + '&destination_lang_id=' + previousLangID,
        })
        .then(function(response) {
            window.location.replace(response);
        }, function(response) {
            window.location.replace(response);
        });
    }
};

// if user outside the UK - open the popup
if ( document.querySelector('.js-popup-purchase-outside-uk') && !UKS.cookie.showCookie('outsideUKConfirmed') ) {
    if ( !sessionStorage.getItem('popupPurchaseOutsideUk') ) {
        setTimeout(function(){
            document.querySelector('.js-popup-purchase-outside-uk').classList.add('popup-wrapper--show');
        }, 1000);
    }
};

UKS.promocode = {
    continue: function(PromoCodeId, url) {
        // UKS.cookie.setCookie('promoCodeConfirmed', PromoCodeId, 9999);
        UKS.cookie.setCookie('promoCodeConfirmed-' + PromoCodeId, PromoCodeId, 9999);
        document.querySelector('.js-popup-promocode').classList.remove('popup-wrapper--show');
        // UKS.trackByFacebookPixel('Lead');
        window.location = url;
    }
};

if ( !document.querySelector('.js-popup-purchase-outside') && document.querySelector('.js-popup-promocode:not(.popup-wrapper--was-shown)') ) {

    if ( !UKS.cookie.showCookie('promoCodeConfirmed-' + document.querySelector('.js-popup-promocode').getAttribute('data-id')) ) {
        if ( !sessionStorage.getItem('popupPromoCode-' + document.querySelector('.js-popup-promocode').getAttribute('data-id')) ) {
            setTimeout(function(){
                document.querySelector('.js-popup-promocode').classList.add('popup-wrapper--show');
            }, 2000);
        }
    }
}

$('.js-dropdown-btn').on('click', function() {
    $(this).next().fadeToggle();
});

UKS.utils.imgGallery = function imgGallery() {
    $('.js-thumb-item').on('click', function(event) {
        $('.js-thumb-preview').attr('src', event.target.getAttribute('data-img-url'));

        var elName = $(this).attr('data-figcaption');
        $('.js-thumb-figcaption').html(elName);

        var labelInfo = $(this).attr('data-sexed');
        
        if ( labelInfo === "yes" ) {
            $('.js-thumb-label').show(); 
        } else {
            $('.js-thumb-label').hide(); 
        }
        

        $('.js-thumb-item').parent().removeClass('active');
        $(this).parent().addClass('active');
        return false;
    });
};


Math.sign = Math.sign || function(x) {
    x = +x; 
    if (x === 0 || isNaN(x)) {
      return x;
    }
    return x > 0 ? 1 : -1;
}

UKS.utils.drawProgressBar = function drawProgressBar() {
    var tprogressTableRow = $('.progress-table__row');


    var coordinatesLeftSide = $(".js-left-coordinate").map((i, item) => {
        return item.innerHTML;
    });
    var diferenceBetweenLeftCoordinates = coordinatesLeftSide[2] - coordinatesLeftSide[1];
    var coordinateLeftConstant = -(+coordinatesLeftSide[2] + diferenceBetweenLeftCoordinates);

    var coordinatesRightSide = $(".js-right-coordinate").map((i, item) => {
        return item.innerHTML;
    });
    var diferenceBetweenRightCoordinates = coordinatesRightSide[2] - coordinatesRightSide[1];
    var coordinateRightConstant = coordinatesRightSide[0] - diferenceBetweenRightCoordinates;    

    [].forEach.call(tprogressTableRow, function(el) {
        var $this = $(el);
        var progressValue = $this.attr('data-progress-value');
        var progressColor = $this.attr('data-progress-color');
        var scaleSize = $this.attr('data-scale-value');
        var percent = 100;
        var progressValueSign = Math.sign(progressValue);

        if ( scaleSize == 1){
            if ( progressValue > 100) {
                var progressWidth =  ( +progressValue - coordinateRightConstant) * percent / (+coordinatesRightSide[2] - coordinateRightConstant);

                $this.find('.js-progress-bar-right').css({width: progressWidth+'%', background: progressColor});

            } else if (progressValue < 100){
                var progressWidth =  (-progressValue - coordinateLeftConstant) * 100 / (-coordinatesLeftSide[0] - coordinateLeftConstant);

                $this.find('.js-progress-bar-left').css({width: progressWidth+'%', background: progressColor});
            } else if (progressValue == 100){
                var progressWidth =  ( +progressValue - coordinateRightConstant) * percent / (+coordinatesRightSide[2] - coordinateRightConstant);

                $this.find('.js-progress-bar-right').css({width: '1.5%' , background: progressColor});
            }
        } else {
            if ( progressValueSign === 1) {
                var progressWidth =  ( +progressValue - coordinateRightConstant) * percent / (+coordinatesRightSide[2] - coordinateRightConstant);
    
                if( +progressValue < +coordinatesRightSide[0]) {
                    percent = 33.33333;
                    progressWidth =  +progressValue * percent / coordinatesRightSide[0];
                }
                
                $this.find('.js-progress-bar-right').css({width: progressWidth+'%', background: progressColor});
                
            } else if (progressValueSign === -1){
                var progressWidth =  (-progressValue - coordinateLeftConstant) * 100 / (-coordinatesLeftSide[0] - coordinateLeftConstant);
    
                if( +progressValue > +coordinatesLeftSide[2]) {
                    percent = 33.33333;
                    progressWidth =  +progressValue * percent / +coordinatesLeftSide[2];
                }
                $this.find('.js-progress-bar-left').css({width: progressWidth+'%', background: progressColor});
            } 
        }    
    });

};

UKS.preventPageJumping = function(el) {
    let url = $(el).attr('data-url');

    return callApi({
        url: url,
        method: 'GET',
        onSuccess: function(response) {
            $('#js-table-container').html(response);
        }
    });
};

UKS.colorForPointetElement = function() {
    let pointedElement = $('.js-pointed');
    let getColor = pointedElement.data('color');
    pointedElement.css({'background-color': getColor});
}

UKS.openSubscribePopup = function() {
    let popupContent = $('.js-subscribe-content');

    popupContent.addClass('popup-wrapper--show');
}

UKS.openMapPopup = function() {
    let popupContent = $('.js-map-popup');

    popupContent.addClass('popup-wrapper--show');
}

UKS.openPopupOnClick = function() {

    $('body').on("click", '.js-popup-open', function() {
        var popupButtonDataName = $(this).attr('data-name');
        var popupDataContent = $(`[data-content="${popupButtonDataName}"]`);
        var popupContentCloseBtn = popupDataContent.find('.popup__close');

        popupDataContent.addClass('popup-wrapper--show');

        popupContentCloseBtn.on("click", function() {
            popupDataContent.removeClass('popup-wrapper--show');
        });
    });        
};


$(document).ready(function() {
    UKS.utils.infiniteScroll(UKS.utils.makeEqualHeadline);
    UKS.utils.cardNumberValidation();
    UKS.utils.showMore();
    UKS.utils.showDeliveryOptions();
    UKS.utils._openPopupOnClick();
    UKS.utils.makeEqualHeadline();
    UKS.utils.navLeft();
    UKS.shoppingBag.init();
    UKS.selectBoxes();
    UKS.utils.imgGallery();
    UKS.utils.drawProgressBar();
    UKS.colorForPointetElement();
    UKS.openPopupOnClick();

    // if ($('#js-content').length) {
    //     UKS.refinement.initPopstate();
    // }

    $('.js-close-popup').on('click', function () {
        $(this).closest('.js-popup').removeClass('popup-wrapper--show');
   });

    UKS.refinement.init();

    $('.js-fadeIn-animation').viewportChecker({
        classToAdd: 'visible animated fadeIn',
        offset: 100
    });

    $('.js-fadeInDown-animation').viewportChecker({
        classToAdd: 'visible animated fadeInDown',
        offset: 100
    });

    $('.js-fadeInUp-animation').viewportChecker({
        classToAdd: 'visible animated fadeInUp',
        offset: 100
    });

    $('.js-fadeInLeft-animation').viewportChecker({
        classToAdd: 'visible animated fadeInLeft',
        offset: 100
    });

    $('.js-fadeInRight-animation').viewportChecker({
        classToAdd: 'visible animated fadeInRight',
        offset: 100
    });

    $('.js-decreaseIn-animation').viewportChecker({
        classToAdd: 'visible animated decreaseIn',
        offset: 100
    });

    $('.js-fadeInDownSmallTop-animation').viewportChecker({
        classToAdd: 'visible animated fadeInDownSmallTop',
        offset: 100
    });

});

